import React from 'react';
import './ConstructionBanner.css';

const ConstructionBanner = () => {
  return (
    <div className="construction-banner">
      <div className="construction-content">
        <span className="construction-icon">🚧</span>
        <span className="construction-text">Aunque nuestro sitio web está en construcción, ya puedes contactarnos por WhatsApp.</span>
      </div>
    </div>
  );
};

export default ConstructionBanner; 